import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageCropperModule} from 'ngx-image-cropper';

import {EditorInterfaceComponent} from './editor-interface/editor-interface.component';
import {DiagramRenderModule} from '../diagram-render/diagram-render.module';
import {CoreModule} from '../core/core.module';
import {SidebarService} from './sidebar/sidebar.service';
import {ConfirmDeleteDialogComponent} from './dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import {UsersOnlineService} from './toolbar/users-online.service';
import {SyncUrlsPopupComponent} from './toolbar/sync-urls-popup/sync-urls-popup.component';
import {SearchDiagramComponent} from './toolbar/search-diagram/search-diagram.component';
import {ImportDrilldownDialogComponent} from './dialogs/import-drilldown-dialog/import-drilldown-dialog.component';
import {ExportDrilldownDialogComponent} from './dialogs/export-drilldown-dialog/export-drilldown-dialog.component';
import {DiagramCommentsComponent} from './toolbar/diagram-comments/diagram-comments.component';
import {ActivityRenumberDialogComponent} from './dialogs/activity-renumber-dialog/activity-renumber-dialog.component';
import {ConfirmDialogComponent} from './dialogs/confirm-dialog/confirm-dialog.component';
import {ErrorDialogComponent} from './dialogs/error-dialog/error-dialog.component';
import {SwimlanesService} from '../diagram-interaction/services/swimlanes.service';
import {DragulaModule} from 'ng2-dragula';
import {GroupActionButtonsComponent} from './toolbar/group-action-buttons/group-action-buttons.component';
import {MapTreeDialogComponent} from './dialogs/map-tree-dialog/map-tree-dialog.component';
import {TreeModule} from 'ng-tree-component';
import {MapTreeNodeComponent} from './dialogs/map-tree-dialog/map-tree-node/map-tree-node.component';
import {AttachmentsModule} from '../diagram-interaction/attachments/attachments.module';
import {AttachUrlDialogComponent} from './dialogs/attach-url-dialog/attach-url-dialog.component';
import {VertexLinkService} from './services/vertex-link.service';
import {ConfirmPrintDialogComponent} from './dialogs/confirm-print-dialog/confirm-print-dialog.component';
import {ChangesTabStoreService} from './sidebar/activity-sidebar/changes-tab/changes-tab-store.service';
import {TrainingNavigationComponent} from './toolbar/training-navigation/training-navigation.component';
import {TrainingPopupComponent} from './shared/training-popup/training-popup.component';
import {DiagramDetailsComponent} from './toolbar/diagram-details/diagram-details.component';
import {DiagramUserDetailsComponent} from './toolbar/diagram-details/user-details/diagram-user-details.component';
import {HelpDialogComponent} from './toolbar/help-dialog/help-dialog.component';
import {OnlineUsersMenuComponent} from './toolbar/online-users-menu/online-users-menu.component';
import {ToolbarStateService} from './toolbar/toolbar-state.service';
import {MaterialModule} from '../material.module';
import {EditorInterfaceSharedModule} from './shared/editor-interface-shared.module';
import {ChangeDiagramThemeComponent} from './dialogs/change-diagram-theme/change-diagram-theme.component';
import {ChangelogPopupComponent} from './dialogs/changelog-popup/changelog-popup.component';
import {ThemeListComponent} from './shared/theme-list/theme-list.component';
import {AuthorisationNavigationComponent} from './toolbar/authorisation-navigation/authorisation-navigation.component';
import {AuthorisationPopupComponent} from './shared/authorisation-popup/authorisation-popup.component';
import {RejectTaskDialogComponent} from './dialogs/reject-task-dialog/reject-task-dialog.component';
import {ChangeLinePointDialogComponent} from './dialogs/change-line-point-dialog/change-line-point-dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {LegendItemTextDialogComponent} from './dialogs/legend-item-text-dialog/legend-item-text-dialog.component';
import {ChangeStickerColorDialogComponent} from './dialogs/change-sticker-color-dialog/change-sticker-color-dialog.component';
import {FilterNotesDialogComponent} from './dialogs/filter-notes-dialog/filter-notes-dialog.component';
import {HeaderColorPickerComponent} from './dialogs/header-color-picker/header-color-picker.component';

import {GenerationProgressService} from '../shared/service/generation-progress.service';
import {TranslateModule} from '@ngx-translate/core';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {AutoGenerateDrilldownDialogModule} from '../auto-generate-drilldown-dialog/auto-generate-drilldown-dialog.module';
import {ChangeFontDialogComponent} from './dialogs/change-font-dialog/change-font-dialog.component';
import {ChangeTagsDialogComponent} from './dialogs/change-tags-dialog/change-tags-dialog.component';
import {UseExistingDiagramDialogComponent} from './dialogs/use-existing-diagram-dialog/use-existing-diagram-dialog.component';
import {CommonWrapperDialogService} from '../shared/service/common-wrapper-dialog.service';
import {SignOffAuthorisationComponent} from './dialogs/sign-off-authorisation/sign-off-authorisation.component';
import {Q9HtmlDecoderPipe} from '@q9elements/ui-kit/common';
import {ActivityReorderDialogComponent} from './dialogs/activity-reorder-dialog/activity-reorder-dialog.component';
import {CreditWarningDialogComponent} from './dialogs/credit-warning-dialog/credit-warning-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    DiagramRenderModule,
    DragulaModule,
    AttachmentsModule,
    TreeModule,
    MaterialModule,
    EditorInterfaceSharedModule,
    DragDropModule,
    ImageCropperModule,
    TranslateModule,
    MatInputModule,
    MatFormFieldModule,
    EditorInterfaceComponent,
    ConfirmDeleteDialogComponent,
    SyncUrlsPopupComponent,
    SearchDiagramComponent,
    ImportDrilldownDialogComponent,
    ExportDrilldownDialogComponent,
    DiagramCommentsComponent,
    ActivityRenumberDialogComponent,
    LegendItemTextDialogComponent,
    ConfirmDialogComponent,
    ErrorDialogComponent,
    GroupActionButtonsComponent,
    MapTreeDialogComponent,
    MapTreeNodeComponent,
    AttachUrlDialogComponent,
    ConfirmPrintDialogComponent,
    TrainingNavigationComponent,
    TrainingPopupComponent,
    AuthorisationPopupComponent,
    DiagramDetailsComponent,
    DiagramUserDetailsComponent,
    HelpDialogComponent,
    OnlineUsersMenuComponent,
    ChangeDiagramThemeComponent,
    ChangelogPopupComponent,
    ThemeListComponent,
    AuthorisationNavigationComponent,
    RejectTaskDialogComponent,
    SignOffAuthorisationComponent,
    ChangeLinePointDialogComponent,
    ChangeStickerColorDialogComponent,
    ChangeFontDialogComponent,
    FilterNotesDialogComponent,
    HeaderColorPickerComponent,
    AutoGenerateDrilldownDialogModule,
    ChangeTagsDialogComponent,
    UseExistingDiagramDialogComponent,
    ActivityReorderDialogComponent,
    CreditWarningDialogComponent
  ],
  providers: [
    SidebarService,
    UsersOnlineService,
    SwimlanesService,
    VertexLinkService,
    ChangesTabStoreService,
    ToolbarStateService,
    GenerationProgressService,
    CommonWrapperDialogService,
    Q9HtmlDecoderPipe
  ]
})
export class EditorInterfaceModule {}
